import { Bbox } from 'ais-facade-api/api';

export const useBboxValidation = () => {
  const isValidBbox = (bbox: Bbox): boolean => {
    const { first, second } = bbox;
    return (
      first.latitude >= -90 &&
      first.latitude <= 90 &&
      first.longitude >= -180 &&
      first.longitude <= 180 &&
      second.latitude >= -90 &&
      second.latitude <= 90 &&
      second.longitude >= -180 &&
      second.longitude <= 180
    );
  };

  return { isValidBbox };
};
